export default "__VITE_ASSET__CEQ32cjv__"